import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classnames from 'classnames';
import React__default from 'react';
import useCanvasId from '../../../../utils/useCanvasId.js';
import ResizeButton from '../ResizeButton/index.js';
import { SortableHeader } from '../SortableHeader/index.js';
import TooltipHeader from '../TooltipHeader.js';
import { SET_COLUMN } from '../utils/constants.js';
import { useTable } from '../utils/hooks.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Header = function Header(_ref) {
  var columnData = _ref.columnData,
    classesForColumn = _ref.classesForColumn,
    stylesForColumn = _ref.stylesForColumn;
  var _useTable = useTable(),
    dataTestId = _useTable.state.dataTestId,
    dispatch = _useTable.dispatch;
  var isResizable = columnData === null || columnData === void 0 ? void 0 : columnData.resizable;
  if (typeof (columnData === null || columnData === void 0 ? void 0 : columnData.width) === 'string' && columnData.width.includes('%')) {
    console.error("Hey Canvas User! Looks like you're setting a percentage based width. This isn't supported please update the width in columnData or defaultColDef to a pixel number");
  }

  //for resizableButton a11y
  var columnTextId = useCanvasId(null, 'column-header');
  var handleSetHeaderWidth = function handleSetHeaderWidth(newWidth) {
    if (newWidth <= 44) {
      return;
    }
    dispatch({
      payload: {
        field: columnData === null || columnData === void 0 ? void 0 : columnData.field,
        width: newWidth
      },
      type: SET_COLUMN
    });
  };
  var columnClasses = classnames('C-TableAdvanced__headerCell', {
    'hc-txt-capitalize': !(columnData !== null && columnData !== void 0 && columnData.headerName),
    isResizable: isResizable
  }, classesForColumn);
  var headerStyles = _objectSpread({
    width: "".concat(columnData.width, "px")
  }, stylesForColumn);
  var columnText = (columnData === null || columnData === void 0 ? void 0 : columnData.headerName) || (columnData === null || columnData === void 0 ? void 0 : columnData.field);
  return columnData.sortable ? /*#__PURE__*/React__default.createElement(SortableHeader, {
    style: headerStyles,
    columnClasses: columnClasses,
    column: columnData,
    columnText: columnText,
    columnTextId: columnTextId,
    columnWidth: columnData.width,
    tooltipText: columnData.tooltipText
  }, isResizable && /*#__PURE__*/React__default.createElement(ResizeButton, {
    columnTextId: columnTextId,
    headerWidth: columnData.width,
    setHeaderWidth: handleSetHeaderWidth
  })) : /*#__PURE__*/React__default.createElement("th", {
    key: "headerCell-".concat(columnData === null || columnData === void 0 ? void 0 : columnData.field),
    className: columnClasses,
    scope: "col",
    role: "columnheader",
    "data-testid": dataTestId ? "".concat(dataTestId, "-header-").concat(columnData === null || columnData === void 0 ? void 0 : columnData.field) : null,
    style: headerStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "C-HeaderCell__cellOverflow"
  }, /*#__PURE__*/React__default.createElement(TooltipHeader, {
    columnTextId: columnTextId,
    headerText: columnText,
    tooltipText: columnData.tooltipText
  })), isResizable && /*#__PURE__*/React__default.createElement(ResizeButton, {
    columnTextId: columnTextId,
    headerWidth: columnData.width,
    setHeaderWidth: handleSetHeaderWidth
  }));
};

export { Header as default };
